import { useEffect, useState } from 'react';
import { useNavigate, NavigateFunction } from 'react-router-dom';
import { useEnhancedAuth } from '../../context/EnhancedAuthContext';
import { Sight } from '../../context/SightContext';

const tenantKey = import.meta.env.VITE_REACT_APP_TENANT as string | undefined;

/**
 * Navigates to the first available sight using the same URL pattern as the sidebar.
 * Falls back to currentShop if VITE_REACT_APP_TENANT is not set.
 */
export function navigateToFirstSight(
  sights: Sight[],
  currentShop: string | null,
  navigate: NavigateFunction
) {
  const firstSight = sights[0];
  if (!firstSight) return;

  const tenant = tenantKey || (currentShop ? encodeURIComponent(currentShop) : '');
  const identifier = firstSight.slug;
  navigate(`/${tenant}/sight/${identifier}`, { replace: true });
}

export default function IndexRedirect() {
  const navigate = useNavigate();
  const { user } = useEnhancedAuth();
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    // Prevent infinite redirect loops
    if (isProcessing) return;
    
    if (user) {
      setIsProcessing(true);
      // Always redirect to /neo-intelligence as centralized routing gateway
      // console.log('IndexRedirect: Redirecting to /neo-intelligence as centralized routing gateway');
      navigate('/neo-intelligence', { replace: true });
      setIsProcessing(false);
    } else {
      navigate('/signin', { replace: true });
    }
  }, [user, isProcessing, navigate]);

  // Never render anything - let the routing handle content display
  return null;
}
